export default __webpack_public_path__ + "static/media/dyeing.9a764fc3.jpg";